import React from 'react';
import styled from 'styled-components';

import EngineIcon from '@/assets/svg/detailed-car/previewSpecification/engine/any.svg';
import BodyTypeIcon from '@/assets/svg/car/body/suv.svg';
import OperationParamIcon from '@/assets/svg/detailed-car/specification/operationParam.svg';
import EquipmentIcon from '@/assets/svg/detailed-car/specification/equipment_black.svg';
import LikeIcon from '@/assets/svg/detailed-car/specification/like.svg';
import BatteryIcon from '@/assets/svg/detailed-car/previewSpecification/battery/battery.svg';
import { colors } from '@/constants/theme';

import {
  CodeItems,
  DetailedCarFullSpecificationProps,
} from './DetailedCarFullSpecification.types';
import SpecificationCollapse from './components/SpecificationCollapse';

function DetailedCarFullSpecification({
  array,
}: DetailedCarFullSpecificationProps) {
  if (!array || array.length === 0) {
    return null;
  }

  const iconMap: Record<CodeItems, React.ReactNode> = {
    engine: <EngineIcon />,
    body: <BodyTypeIcon />,
    operation_params: <OperationParamIcon />,
    battery: <BatteryIcon className="batteryIcon" />,
    complectation: <EquipmentIcon />,
    like: <LikeIcon />,
  };

  return (
    <Component>
      {array.map((item, index) => {
        return (
          <SpecificationCollapse
            key={index}
            icon={iconMap[item.code]}
            label={item.name}
            items={item.items}
            isOpened={item.isOpened}
          />
        );
      })}
    </Component>
  );
}

export default DetailedCarFullSpecification;

const Component = styled.div`
  svg {
    path {
      fill: ${(props) => props.theme.black100};
    }

    circle {
      stroke: ${(props) => props.theme.black100};
    }
  }

  .batteryIcon {
    fill: none;

    path:nth-child(1) {
      fill: none;
    }

    path:nth-child(1),
    path:nth-child(2) {
      stroke: ${(props) => props.theme.black100};
    }
  }

  .expanded {
    svg {
      path {
        fill: ${colors.main};
      }

      circle {
        stroke: ${colors.main};
      }
    }

    & > .batteryIcon {
      path:nth-child(1),
      path:nth-child(2) {
        stroke: ${colors.main};
      }
    }
  }
`;
